import { DiscountTypesEnum } from "helpers/constants";

export const initialDiscountValues = {
  name: "",
  discountNumber: 0,
  code: "",
  discountType: DiscountTypesEnum.PERCENTAGE,
};
